import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  price?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'DESCARGAR MANUAL AHORA',
  price = '$19.00 USD',
  className = '',
  href,
  onClick
}: CTAButtonProps) {
  const Tag = href ? motion.a : motion.button;
  const linkProps = href ? {
    href,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return <Tag {...linkProps} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group relative flex flex-col items-center justify-center w-full sm:w-auto overflow-hidden rounded-xl bg-accent px-8 py-4 font-bold text-background shadow-[0_0_40px_rgba(212,168,83,0.3)] transition-all hover:bg-accent-hover hover:shadow-[0_0_60px_rgba(212,168,83,0.5)] no-underline ${className}`} data-id="element-241">
      <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-150%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(150%)]" data-id="element-242">
        <div className="relative h-full w-8 bg-white/20" data-id="element-243" />
      </div>

      <span className="relative flex items-center gap-2 text-lg sm:text-xl uppercase tracking-wide" data-id="element-244">
        {text}
        <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-245" />
      </span>
      {price && <span className="relative mt-1 text-sm font-medium opacity-90" data-id="element-246">
          Precio: {price}
        </span>}
    </Tag>;
}